module.exports = __webpack_public_path__ + "img/svg/mobile.8048be5d2d6b9ed92388d3fccf4461b7.svg";